import * as types from './type';


const initialState = {
    postAdData: '',
    ads: '',
    postAdData2: '',
};



export default function postDataReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.SET_PROPERTY_DATA: {
      if (action.payload) {
        
        return {
          ...state,
          postAdData: action.payload
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.SET_PROPERTY_STEP2_DATA: {
      if (action.payload) {
        
        return {
          ...state,
          postAdData2: action.payload
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.POST_A_ADD: {
      if (action.payload.data) {
        
        return {
          ...state,
          ads: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    
    default: {
      return {
        ...state
      };
    }
    
  }

}